<template>
  <div class="HomePage">
    <!-- Slogan -->
    <section class="Slogan">
      <h1>Innovation & Expertise en Électronique et Impression 3D</h1>
      <p>
        De la conception de circuits imprimés à la réalisation de pièces sur-mesure en impression 3D filament et résine.
      </p>
    </section>

    <!-- Services -->
    <section class="Services" id="services">
      <h2>Nos Services</h2>
      <div class="ServicesGrid">
        <div class="ServiceCard">
          <div class="card-header">
            <img src="@/assets/Images/Services/pcb.png" alt="Circuits imprimés">
            <h3>Création de circuits imprimés</h3>
          </div>
          <div class="service-list">
            <ul>
              <li><a href="#" @click="$router.push('/schematics')">Conception de schémas / routage</a></li>
              <li><a href="#" @click="$router.push('/analyse')">Analyse schémas / routage</a></li>
              <li><a href="#" @click="$router.push('/assembly')">Assemblage de composants</a></li>
            </ul>
          </div>
        </div>
        <div class="ServiceCard">
          <div class="card-header">
            <img src="@/assets/Images/Services/3d-filament.png" alt="Impression 3D filament">
          <h3>Impression 3D</h3>
          </div>
          <div class="service-list">
            <ul>
              <li><a href="#" @click="$router.push('/filament')">Impression 3D FDM (filament PLA, PETG, ABS...)</a></li>
              <li><a href="#" @click="$router.push('/resine')">Impression 3D résine (SLA/DLP)</a></li>
              <li><a href="#" @click="$router.push('/conception3D')">Conception modèles 3D</a></li>
              
            </ul>
          </div>
        </div>
       <div class="ServiceCard">
          <div class="card-header">
            <img src="@/assets/Images/Services/embedded.png" alt="Code Embarqué">
            <h3>code</h3>
          </div>
          <div class="service-list">
            <ul>
              <li><a href="#" >Systèmes embarqués en C/C++</a></li>
              <li><a href="#">Logiciels en Python/C#/Android/IOS</a></li>
              <li><a href="#">Site web Vue.js</a></li>
              
            </ul>
          </div>
        </div>
        
      </div>
    </section>
    <section class="nouvautées">
    <h2>Découvrez aussi nos projets :</h2>
    
    <!-- Carrousel -->
    <section class="CarrouselSection">
      <div class="Carrousel">
        <ChessboardM 
          :size="'400px'"
          :show-status="true"
          @move="handleChessMove"
        />


        <div class="CarrouselText">
          <h2>DEONchess </h2>
          <p>
            l’échiquier connecté!</p>
            <p>
              découvrez notre système de contrôle d’échiquier électronique, simple et intuitif, pour tous vos besoins de jeu ou d’analyse.
          </p>
        </div>
      </div>
    </section>
    <section class="CarrouselSection">
      <div class="Carrousel">
        <img class="carrouselImages" src="@/assets/Images/Carrousel/deonmetrix.png"/>


        <div class="CarrouselText">
          <h2>DEONMETRIX</h2>
          <p>
            Découvrez notre multimètre, bientôt disponible...
          </p>
        </div>
      </div>
    </section>
  <section class="CarrouselSection">
      <div class="Carrousel">
        


        <div class="CarrouselText">
          <h2>Coming soon...</h2>
          
        </div>
      </div>
    </section>
  </section>
  </div>
</template>

<script>
import ChessboardM from '@/components/ChessboardMain.vue'

export default {
  name: "HomePage",
  components: {
    ChessboardM
  },
  methods: {
    handleChessMove(moveData) {
      console.log('Coup joué:', moveData)
      // Tu peux traiter les événements de l'échiquier ici
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Fira+Mono:wght@400;500;700&family=Montserrat:wght@300;400;600;700&display=swap');

.carrouselImages {
  width: 50%;
  max-width: 400px;
  height: auto;
}

.nouvautées {
  margin: var(--spacing-xxl) auto;
  max-width: 1400px;
  padding: 0 var(--spacing-sm);
}

.nouvautées h2 {
  text-align: center;
  font-family: deonstudio;
  font-size: clamp(1.8rem, 4vw, 2.5rem);
  margin-bottom: var(--spacing-xl);
  color: var(--text-secondary);
  letter-spacing: 2px;
}

.HomePage {
  min-height: 100vh;
  background: transparent;
  font-family: 'Montserrat', Arial, sans-serif;
  color: var(--text-secondary);
  padding-bottom: var(--spacing-lg);
}

.Highlight {
  color: var(--text-red);
}

/* Slogan */
.Slogan {
  text-align: left;
  
  max-width: 1000px;
  padding: 2% var(--spacing-lg);
}

.Slogan h1 {
  text-align: left;
  font-size: clamp(2rem, 5vw, 3rem);
  margin-bottom: var(--spacing-md);
  color: var(--text-secondary);
  font-family: deonstudio;
  line-height: 1.2;
}

.Slogan p {
  text-align: left;
  font-size: clamp(1rem, 2.5vw, 1.3rem);
  color: var(--text-secondary);
  line-height: 1.6;
  max-width: 800px;
  margin: 0;
}

/* Carrousel */
.CarrouselSection {
  display: flex;
  justify-content: center;
  margin-bottom: var(--spacing-xl);
  padding: 0 var(--spacing-sm);
}

.Carrousel {
  width: 100%;
  max-width: 1200px;
  min-height: 350px;
  padding: var(--spacing-lg);
  border-radius: var(--radius-medium);
  background: var(--bg-tertiary);

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  gap: var(--spacing-lg);
  box-shadow:  5px 5px 10px #d9d9d9,
              -5px -5px 10px #ffffff;
}

.CarrouselText {
  font-family: 'Montserrat', Arial, sans-serif;
  color: var(--text-secondary);
  text-align: left;
  width: 90%;
  max-width: 90%;
  padding: var(--spacing-sm);
  z-index: 2;
  position: relative;
}

.CarrouselText h2 {
  text-align: left;
  font-family: deonstudio;
  margin: 0 0 var(--spacing-sm) 0;
  font-size: clamp(1.5rem, 3vw, 2.2rem);
  color: var(--text-red);
  letter-spacing: 1px;
}

.CarrouselText p {
  text-align: left;
  margin: 0 0 var(--spacing-sm) 0;
  font-size: clamp(1rem, 2vw, 1.2rem);
  color: var(--text-secondary);
  line-height: 1.5;
}

/* Services - Style DigiKey */
.Services {
  margin: var(--spacing-xxl) auto;
  max-width: 1400px;
  text-align: center;
  padding: 0 var(--spacing-lg);
}

.Services h2 {
  font-family: deonstudio;
  font-size: clamp(1.8rem, 4vw, 2.5rem);
  margin-bottom: var(--spacing-xl);
  color: var(--text-secondary);
  letter-spacing: 2px;
}

.ServicesGrid {
  
  align-content: center;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--spacing-lg);
  width: 100%;
  
}

/* ServiceCard - Style DigiKey inspiré */
.ServiceCard {
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  padding: var(--spacing-lg);
  min-height: 320px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  transition: all var(--transition-normal);
  position: relative;
  overflow: hidden;
  box-shadow:  5px 5px 10px #d9d9d9,
              -5px -5px 10px #ffffff;
}

.ServiceCard:hover {
  border-color: var(--text-red);
  transform: translateY(-2px);
}

/* Header de la carte avec image */
.ServiceCard .card-header {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: var(--spacing-md);
  padding-bottom: var(--spacing-sm);
  border-bottom: var(--border-primary);
}

.ServiceCard img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-right: var(--spacing-sm);
  background: transparent;
  padding: 4px;
  transition: all var(--transition-normal);
}

.ServiceCard:hover img {
  transform: scale(1.05);
}

.ServiceCard h3 {
  color: var(--text-red);
  margin: 0;
  font-size: clamp(1.1rem, 2vw, 1.3rem);
  font-family: deonstudio;
  letter-spacing: 0.5px;
  font-weight: 600;
}

/* Liste des services */
.ServiceCard .service-list {
  width: 100%;
  flex: 1;
}

.ServiceCard .service-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.ServiceCard .service-list li {
  margin-bottom: var(--spacing-xs);
  padding: var(--spacing-xs) 0;
  border-bottom: 1px solid var(--card-border);
}

.ServiceCard .service-list li:last-child {
  border-bottom: none;
}

.ServiceCard .service-list a {
  color: var(--text-link);
  text-decoration: none;
  font-size: clamp(0.9rem, 1.5vw, 1rem);
  font-weight: 500;
  transition: color var(--transition-fast);
}

.ServiceCard .service-list a:hover {
  color: var(--text-red);
  text-decoration: underline;
}

/* Description alternative pour les cartes sans liste */
.ServiceCard p {
  color: var(--text-secondary);
  font-size: clamp(0.9rem, 1.5vw, 1rem);
  line-height: 1.5;
  margin: 0;
  flex: 1;
}

/* Chess styles */
.chessboard-container {
  position: relative;
  width: 100%;
  max-width: 400px;
  aspect-ratio: 1/1;
  margin: 0 auto;
  font-family: deonstudio;
  border-radius: var(--radius-medium);
  overflow: hidden;
}

.board-image {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  z-index: 1;
}

.coordinates {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  z-index: 2;
  pointer-events: none;
}

.chess-board {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  display: grid;
  grid-template-rows: repeat(8, 1fr);
  grid-template-columns: repeat(8, 1fr);
  z-index: 3;
}

.row { display: contents; }

.square {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  transition: background var(--transition-fast);
}

.square.light { background: transparent; }
.square.dark { background: transparent; }
.square.selected { 
  background: var(--primary-red-alpha-40) !important; 
}
.square.capture { 
  background: rgba(255,0,0,0.3) !important; 
}

.possible-move {
  position: absolute;
  width: 20px; height: 20px;
  border-radius: 50%;
  background: var(--green-alpha-40);
  z-index: 4;
  pointer-events: none;
}

.capture-indicator {
  position: absolute;
  width: 100%; height: 100%;
  border: 3px solid rgba(255,0,0,0.7);
  border-radius: 50%;
  box-sizing: border-box;
  z-index: 4;
  pointer-events: none;
}

.piece {
  width: 90%; height: 90%;
  object-fit: contain;
  user-select: none;
  z-index: 5;
  position: relative;
  transition: transform var(--transition-fast);
}

.piece:hover {
  transform: scale(1.1);
}

.coordinate-light {
  font-family: deonstudio;
  fill: var(--text-red);
}

.coordinate-dark {
  font-family: deonstudio;
  fill: #FAFDF6;
}

.status {
  text-align: center;
  font-size: clamp(1rem, 2vw, 1.2rem);
  margin-top: 15px;
  color: var(--accent-green);
  font-family: deonstudio;
  font-weight: bold;
}

.chessBoardWithStatus {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  flex: 1;
}

/* Responsive - Tablet */
@media (max-width: 1024px) {
  .ServicesGrid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: var(--spacing-md);
  }
  
  .Carrousel {
    padding: var(--spacing-md);
    min-height: 320px;
  }
  
  .chessboard-container {
    max-width: 350px;
  }
}

/* Responsive - Mobile */
@media (max-width: 768px) {
  .Slogan {
    margin: var(--spacing-lg) auto;
    padding: 0 var(--spacing-sm);
  }
  
  .Services {
    padding: 0 var(--spacing-sm);
  }
  
  .ServicesGrid {
    grid-template-columns: 1fr;
    gap: var(--spacing-md);
  }
  
  .ServiceCard {
    min-height: 280px;
    padding: var(--spacing-md);
  }
  
  .Carrousel {
    flex-direction: column;
    height: auto;
    min-height: 450px;
    padding: var(--spacing-lg) var(--spacing-sm);
    gap: var(--spacing-md);
  }

  .chessboard-container {
    max-width: 280px;
    margin-bottom: var(--spacing-sm);
  }

  .CarrouselText {
    max-width: 100%;
    text-align: left;
    padding: 0;
  }
  
  .carrouselImages {
    width: 80%;
    max-width: 300px;
  }
  
  .nouvautées {
    margin: var(--spacing-lg) auto;
    padding: 0 var(--spacing-sm);
  }
}

/* Small mobile */
@media (max-width: 480px) {
  .Slogan {
    padding: 0 var(--spacing-xs);
  }
  
  .Services {
    padding: 0 var(--spacing-xs);
  }
  
  .ServiceCard {
    padding: var(--spacing-sm);
    min-height: 250px;
  }
  
  .ServiceCard img {
    width: 50px;
    height: 50px;
  }
  
  .Carrousel {
    padding: var(--spacing-md) 0.8rem;
    min-height: 400px;
  }
  
  .chessboard-container {
    max-width: 250px;
  }
  
  .CarrouselText h2 {
    font-size: 1.3rem;
  }
  
  .CarrouselText p {
    font-size: 0.9rem;
  }
  
  .carrouselImages {
    width: 90%;
    max-width: 250px;
  }
}

/* Large screens */
@media (min-width: 1200px) {
  .ServicesGrid {
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
  }
  
  .ServiceCard {
    min-height: 350px;
    padding: var(--spacing-xl);
  }
  
  .Carrousel {
    padding: var(--spacing-xl);
    min-height: 400px;
  }
  
  .chessboard-container {
    max-width: 450px;
  }
}

/* Ultra-wide screens */
@media (min-width: 1600px) {
  .Services, .nouvautées {
    max-width: 1600px;
  }
  
  .Carrousel {
    max-width: 1400px;
  }
  
  .ServicesGrid {
    gap: var(--spacing-xl);
  }
}
</style>